module.exports = __webpack_public_path__ + "img/36.5.COD.36e5747f.png";